import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { wosCategoryOptions } from '@/module/Nomen/WosCategory/model/WosCategoryModel';

import { AsyncMultiSelectControl, AsyncSelectControlProps } from '@/core/components';

type WosCategoryMultiSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function WosCategoryMultiSelectControl<T extends FieldValues>(props: WosCategoryMultiSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(wosCategoryOptions.getAll());

  return (
    <AsyncMultiSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
